import { useDispatch, useSelector } from "react-redux";
import { getReportsPeriod } from "../../../store/reports/reports.selectors";
import React, { useCallback } from "react";
import { changePeriod } from "../../../store/reports/reports.actions";
import TimePeriodSelector from "../../../components/charts/timePeriodSelector/TimePeriodSelector";

export const WidgetsTimePeriodSelector = () => {
  const dispatch = useDispatch();

  const period = useSelector(getReportsPeriod);

  const handleTimePeriodChange = useCallback(
    (period) => {
      dispatch(changePeriod(period));
    },
    [dispatch]
  );

  return (
    <TimePeriodSelector
      showSelector={true}
      period={period}
      onChange={handleTimePeriodChange}
    />
  );
};
